import { de, enUS, fr, nlBE, cs, es, it, pt, pl } from 'date-fns/locale';

export const formatDateLocales: { [key: string]: Locale } = {
  us: enUS,
  nl: nlBE,
  fr,
  de,
  cs,
  es,
  it,
  pt,
  pl,
};
